import { render, staticRenderFns } from "./AddressExplorer.vue?vue&type=template&id=3b5db99c&scoped=true&"
import script from "./AddressExplorer.vue?vue&type=script&setup=true&lang=ts&"
export * from "./AddressExplorer.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b5db99c",
  null
  
)

export default component.exports